import AdminApi from '../../services/api'
import swal from 'sweetalert2';
import session from "../../services/session";
import CONFIG_COMPANY from "../../services/myConfig";
import Loc from "../../services/localization";

const AdminApiService = new AdminApi()
const LocService = new Loc()

export default {
    data() {
        return {
            locale: LocService,
            memberships: [],
            dates6 : [],
            dates12 : [],
            showLoyalty: false,
            paymentToBuy: null,
            showDateForMembership: false
        }
    },
    computed : {
        orderedPayments : function () {
            return this.memberships;
        }
    },
    methods: {
        formatDate: formatDate,
        formatDate2: formatDate2,
        load: load,
        buyMemberShip: buyMemberShip,
    },

    created() {
        let _self = this;
        this.$topnavbar.$on('closeChooseDateMemebership', () => {
            _self.paymentToBuy = null;
            _self.showDateForMembership = false;
        });
    },
    beforeMount() {
        this.load()
    }
}



function formatDate2(date) {
    return this.$moment(new Date(date)).format('DD-MM-YYYY')
}

function load() {
    let _self = this;
    AdminApiService.getMemberships()
        .then((response) => {
            _self.memberships = response.data;
        })
        .catch(error => {
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function formatDate(date) {
    return this.$moment(new Date(date * 1000)).format('DD-MM-YYYY')
}

function buyMemberShip(item){
    this.paymentToBuy = item
    this.showDateForMembership = true;
}



// WEBPACK FOOTER //
// ./src/components/Membership/BuyMembershipPackages.js